import { Injectable } from '@angular/core'
import type { IQSubscription } from '@awork/_shared/models/subscription.model'
import { SignalStore } from '@awork/core/state/signal-store/signalStore'

export type SubscriptionState = IQSubscription

export function createInitialState(): IQSubscription {
  return {
    workspaceId: null,
    externalSubscriptionId: null,
    planId: null,
    basePlanId: null,
    termInMonths: null,
    initialPlanId: null,
    contractEnd: null,
    status: null,
    previousStatus: null,
    bookedSeats: null,
    usedUserSeats: null,
    usedGuestSeats: null,
    remainingUsers: null,
    remainingGuests: null,
    totalProjects: null,
    trialEnd: null,
    usedPaidTrial: null,
    customDomainEnabled: null,
    createdBy: null,
    currencyCode: null,
    referralCode: null,
    aiBookedSeats: null,
    aiPaidPlanActive: null,
    aiTrialActive: null,
    pricingModel: null
  }
}

@Injectable({ providedIn: 'root' })
export class SubscriptionStore extends SignalStore<SubscriptionState> {
  constructor() {
    super({
      initialState: createInitialState(),
      name: 'subscription'
    })
  }

  /**
   * Updates the remaining seats
   * @param {number} [amount=-1]
   */
  updateRemainingSeats(amount = -1): void {
    this.update(subscription => {
      return { remainingUsers: subscription.remainingUsers + amount }
    })
  }
}
